var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1111 13.4444C22.864 10.8133 20.144 9 17 9C15.9494 9 14.9091 9.20693 13.9385 9.60896C12.9679 10.011 12.086 10.6003 11.3431 11.3431C10.6003 12.086 10.011 12.9679 9.60896 13.9385C9.20693 14.9091 9 15.9494 9 17C9 18.0506 9.20693 19.0909 9.60896 20.0615C10.011 21.0321 10.6003 21.914 11.3431 22.6569C12.086 23.3997 12.9679 23.989 13.9385 24.391C14.9091 24.7931 15.9494 25 17 25C19.1217 25 21.1566 24.1571 22.6569 22.6569C24.1571 21.1566 25 19.1217 25 17M25 9V14.3333H19.6667",
    stroke: "currentColor",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.e7720663b7d2419e4564a9cc86afc5d4.svg";
export { ForwardRef as ReactComponent };